var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import config from "@/config";
import Handlers from "@/lib/Handlers";
import SplashGame from "@/lib/SplashGame";
import UtilsScale from "@/lib/utils/scale";
import CorePanel from "@/prefabs/core/Panel";
import { NotificationType } from "@/types/Notification";
var PanelNotification = /** @class */ (function (_super) {
    __extends(PanelNotification, _super);
    function PanelNotification(scene, x, y, username) {
        var _this = _super.call(this, scene, x, y) || this;
        _this.scene.add.existing(_this);
        _this.username = username;
        var default_style = {
            fontSize: "36px",
            fontFamily: config.graphics.fontFamily,
        };
        _this.text_winner = new Phaser.GameObjects.Text(scene, -300, 0, username.substring(0, 7), __assign(__assign({}, default_style), { align: "right" })).setOrigin(1, 0.5);
        _this.text_notification = new Phaser.GameObjects.Text(scene, 0, 0, "", __assign(__assign({}, default_style), { align: "center" })).setOrigin(0.5);
        _this.text_loser = new Phaser.GameObjects.Text(scene, 300, 0, "", __assign(__assign({}, default_style), { align: "left" })).setOrigin(0, 0.5);
        // black rounded background
        var graphics = scene.add.graphics();
        graphics.fillStyle(0x0, 0.7);
        graphics.fillRoundedRect(-505, -50, 1010, 100, 46);
        _this.add(graphics);
        // const winnerBGMask = scene.add.graphics();
        // winnerBGMask.setScrollFactor(0);
        // winnerBGMask.fillStyle(0xffffff);
        // winnerBGMask.beginPath();
        // winnerBGMask.fillRoundedRect(0, -50, 120, 120, 46);
        // this.add(winnerBGMask);
        // notification panel
        _this.add(new Phaser.GameObjects.Image(scene, -310, 0, "background.winner-notification"));
        _this.add(new Phaser.GameObjects.Image(scene, 310, 0, "background.loser-notification"));
        _this.bg = new Phaser.GameObjects.Image(scene, 0, 0, "background.kill-notification");
        _this.add(_this.bg);
        // profiles
        // const profileGraphics = scene.add.graphics();
        // profileGraphics.fillStyle(0xffffff, 1);
        // profileGraphics
        //   .fillRoundedRect(-265, -60, 20, 20, 32)
        //   .setVisible(false)
        //   .createBitmapMask();
        // profileGraphics.fillRoundedRect(145, -60, 120, 120, 32);
        // this.add(profileGraphics);
        _this.add(_this.text_winner);
        _this.add(_this.text_notification);
        _this.add(_this.text_loser);
        _this.setScale(0.8);
        _this.setDepth(9990);
        _this.setScrollFactor(0);
        _this.setVisible(false);
        // init handlers
        _this.initHandlers();
        // RESIZE
        _this.RESIZE_H_FACTOR = 1;
        _this.RESIZE_H_MAX = _this.bg.height;
        _this.RESIZE_W_FACTOR = 0.35;
        _this.RESIZE_W_MAX = _this.bg.width;
        return _this;
    }
    PanelNotification.prototype.setPosition = function (x, y, z, w) {
        var _a;
        _super.prototype.setPosition.call(this, x, y + ((_a = this.bg) === null || _a === void 0 ? void 0 : _a.height), z, w);
        return this;
    };
    PanelNotification.prototype.initHandlers = function () {
        var _this = this;
        var i18nHandler = SplashGame.i18nHandler.getInstance();
        Handlers.NotificationHandler.getInstance().on(NotificationType.KILL_STRIKE, function (detail) {
            if (!_this.scene)
                return;
            var loser = detail.loser, strike = detail.strike;
            if (strike < 2)
                return;
            var strike_key = "notification.".concat(Math.min(strike - 2, 7));
            var message = i18nHandler.get(strike_key);
            var audio_key = strike_key;
            _this.notify(loser, message, audio_key);
        });
    };
    PanelNotification.prototype.updateUserIcons = function (loser) {
        this.add(new Phaser.GameObjects.Image(this.scene, -205, 0, "profile-" + this.username).setDisplaySize(118, 118) //user profile pic
        );
        this.add(new Phaser.GameObjects.Image(this.scene, 205, 0, "profile-" + loser).setDisplaySize(118, 118));
        this.add(new Phaser.GameObjects.Image(this.scene, -205, 0, "background.winner-profile"));
        this.add(new Phaser.GameObjects.Image(this.scene, 205, 0, "background.loser-profile"));
    };
    PanelNotification.prototype.notify = function (loser, message, audio_key) {
        var _this = this;
        this.setVisible(true);
        this.setAlpha(1);
        Handlers.AudioHandler.getInstance().play(audio_key);
        this.text_loser.text = loser.substring(0, 7);
        this.text_notification.text = message;
        this.text_notification.setFontSize(UtilsScale.text(message, 36, 11));
        this.updateUserIcons(loser);
        if (this.timer) {
            this.timer.destroy();
        }
        this.timer = this.scene.time.addEvent({
            callback: function () {
                _this.hide();
                _this.timer.destroy();
                _this.timer = null;
            },
            delay: config.gameplay.notification.ms,
            loop: false,
        });
    };
    return PanelNotification;
}(CorePanel));
export default PanelNotification;
